import React from 'react';
import Chart from 'react-apexcharts';

const BillBreakdownChart = ({ chartData }) => {
    if (!chartData || !chartData.pie_chart || !chartData.pie_chart.labels || chartData.pie_chart.labels.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>
                No breakdown data available.
            </div>
        );
    }

    const { pie_chart, total_bill } = chartData;
    const { labels, values } = pie_chart;

    // Brand palette for the breakdown
    const customPalette = [
        '#009f8d', // Enfo Teal
        '#002f46', // Dark Navy
        '#ff9c07', // Enfo Orange
        '#00c6a9', // Light Teal
        '#005051', // Deep Teal
        '#0a0a0a', // Black
        '#007a6c', // Slightly darker Enfo Teal
        '#004466'  // Slightly lighter Dark Navy
    ];

    const options = {
        chart: {
            type: 'donut',
            height: 350
        },
        labels: labels,
        colors: customPalette,
        plotOptions: {
            pie: {
                donut: {
                    size: '65%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '14px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: '#64748b',
                            offsetY: -10
                        },
                        value: {
                            show: true,
                            fontSize: '20px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 'bold',
                            color: '#0f172a',
                            offsetY: 8,
                            formatter: function (val) {
                                return "Rs. " + Number(val).toLocaleString();
                            }
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            label: 'Total Bill',
                            fontSize: '16px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: '#333',
                            formatter: function (w) {
                                return "Rs. " + (total_bill ? total_bill.toLocaleString() : "0");
                            }
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            position: 'bottom',
            fontSize: '13px',
            markers: {
                radius: 12
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "Rs. " + val.toLocaleString();
                }
            }
        }
    };

    return (
        <div style={{ background: '#fff', borderRadius: 16, padding: 20, boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={{ margin: 0, fontSize: 18, color: '#0f172a' }}>Bill Breakdown</h3>
            </div>
            <Chart options={options} series={values} type="donut" height={350} />
        </div>
    );
};



export default BillBreakdownChart;
